/* Bonge: kokotaulukon kahden koon vertailu.
   Lukee koot ja mitat valmiiksi renderoidusta taulukosta, joten dataa ei ole
   markupissa kahteen kertaan. Ilman tata skriptia koko taulukko nakyy
   normaalisti auki. */
(function () {
  if (window.customElements && customElements.get('kokotaulukko-vertailu')) return;

  class KokotaulukkoVertailu extends HTMLElement {
    connectedCallback() {
      this.taulukko = this.querySelector('.kt-kaikki table');
      this.valinta = this.querySelector('.kt-valinta');
      this.napit = this.querySelector('.kt-napit');
      this.vertailu = this.querySelector('.kt-vertailu');
      this.avaa = this.querySelector('.kt-avaa');
      this.vieritys = this.querySelector('.kt-vieritys');
      if (!this.taulukko || !this.valinta || !this.napit || !this.vertailu) return;

      this.lue();
      if (this.koot.length < 2) return;

      this.valitut = [];
      this.piirraNapit();
      this.valinta.hidden = false;
      this.kokoTaulukko(false);

      var oletus = this.dataset.valittu || '';
      if (this.koot.indexOf(oletus) !== -1) {
        this.vaihda(oletus);
      }
    }

    /* Koko taulukko piiloon vertailun tielta. Ilman JavaScriptia se jaa auki
       ja avausnappi pysyy piilossa, joten mitat ovat aina luettavissa. */
    kokoTaulukko(auki) {
      if (!this.avaa || !this.vieritys) return;
      var self = this;
      this.avaa.hidden = false;
      this.avaa.setAttribute('aria-expanded', auki ? 'true' : 'false');
      this.vieritys.hidden = !auki;
      if (!this.avaaKuunneltu) {
        this.avaaKuunneltu = true;
        this.avaa.addEventListener('click', function () {
          self.kokoTaulukko(self.vieritys.hidden);
        });
      }
    }

    /* Poimi mittojen nimet otsikkorivilta ja kokojen arvot runkoriveilta. */
    lue() {
      var otsikot = this.taulukko.querySelectorAll('thead th');
      this.mitat = [];
      for (var i = 1; i < otsikot.length; i++) {
        this.mitat.push(otsikot[i].textContent.trim());
      }
      this.koot = [];
      this.arvot = {};
      var rivit = this.taulukko.querySelectorAll('tbody tr');
      for (var r = 0; r < rivit.length; r++) {
        var solut = rivit[r].children;
        if (!solut.length) continue;
        var koko = solut[0].textContent.trim();
        var arvot = [];
        for (var c = 1; c < solut.length; c++) {
          arvot.push(solut[c].textContent.trim());
        }
        this.koot.push(koko);
        this.arvot[koko] = arvot;
      }
    }

    piirraNapit() {
      var self = this;
      this.napit.textContent = '';
      this.koot.forEach(function (koko) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = koko;
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          self.vaihda(koko);
        });
        self.napit.appendChild(b);
      });
    }

    /* Enintaan kaksi valintaa kerrallaan: kolmas korvaa vanhimman. */
    vaihda(koko) {
      var i = this.valitut.indexOf(koko);
      if (i !== -1) {
        this.valitut.splice(i, 1);
      } else {
        this.valitut.push(koko);
        if (this.valitut.length > 2) this.valitut.shift();
      }
      this.paivita();
    }

    paivita() {
      var self = this;
      var napit = this.napit.children;
      for (var i = 0; i < napit.length; i++) {
        var paalla = this.valitut.indexOf(napit[i].textContent.trim()) !== -1;
        napit[i].setAttribute('aria-pressed', paalla ? 'true' : 'false');
      }

      if (!this.valitut.length) {
        this.vertailu.hidden = true;
        this.vertailu.textContent = '';
        return;
      }

      var thead = document.createElement('thead');
      var otsikkorivi = document.createElement('tr');
      otsikkorivi.appendChild(this.solu('th', '', 'col'));
      this.valitut.forEach(function (koko) {
        otsikkorivi.appendChild(self.solu('th', koko, 'col'));
      });
      thead.appendChild(otsikkorivi);

      var tbody = document.createElement('tbody');
      this.mitat.forEach(function (mitta, idx) {
        var tyhja = self.valitut.every(function (koko) {
          var v = (self.arvot[koko] || [])[idx];
          return !v || v === '–';
        });
        if (tyhja) return;
        var tr = document.createElement('tr');
        tr.appendChild(self.solu('th', mitta, 'row'));
        self.valitut.forEach(function (koko) {
          tr.appendChild(self.solu('td', (self.arvot[koko] || [])[idx] || '–'));
        });
        tbody.appendChild(tr);
      });

      this.vertailu.textContent = '';
      this.vertailu.appendChild(thead);
      this.vertailu.appendChild(tbody);
      this.vertailu.hidden = false;
    }

    solu(tagi, teksti, scope) {
      var el = document.createElement(tagi);
      el.textContent = teksti;
      if (scope) el.setAttribute('scope', scope);
      return el;
    }
  }

  customElements.define('kokotaulukko-vertailu', KokotaulukkoVertailu);
})();
